import { Options } from "@splidejs/splide";
import { initSplideCarousel } from "../../util/carousel";

const settings: Record<string, Options> = {
  default: {
    perPage: 4,
    width: "100%",
    destroy: false,
    arrows: true,
    pagination: true,
    type: "loop",
    breakpoints: {
      768: {
        perPage: 1,
        fixedWidth: "90vw",
        gap: "var(--column-gap)",
        destroy: false,
        perMove: 1,
      },
    },
  },
  overflow: {
    fixedWidth: "max-content",
  },
};

const portraitSettings: Options = {
  perPage: 4,
  width: "100%",
  arrows: false,
  breakpoints: {
    768: {
      perPage: 2,
      gap: "var(--column-gap)",
    },
  },
};

function init() {
  const sliders = document.querySelectorAll(
    ".js-card-carousel"
  ) as NodeListOf<HTMLElement>;
  const portraitSlidersList = document.querySelectorAll(
    ".js-portrait-card-carousel"
  ) as NodeListOf<HTMLElement>;

  for (const slider of sliders) {
    const settingsKey = slider.dataset.sliderType;
    const splideSettings = settingsKey
      ? settings[settingsKey]
      : settings.default;
    initSplideCarousel(slider, splideSettings);
  }

  for (const slider of portraitSlidersList) {
    initSplideCarousel(slider, portraitSettings);
  }
}

export default init;
